import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'tallymark-2', 'Tallymark2', [["path",{"d":"M10 5l0 14"}],["path",{"d":"M14 5l0 14"}]]);